var map = {
	"./ELIKSIR-00242.JPG": 82,
	"./ELIKSIR-00252.JPG": 83,
	"./ELIKSIR-00308.JPG": 84,
	"./ELIKSIR-00371.JPG": 85,
	"./ELIKSIR-00484.JPG": 86,
	"./ELIKSIR-00507.JPG": 87,
	"./RYS_2294.jpg": 88,
	"./RYS_2565.jpg": 89,
	"./RYS_9039.jpg": 90,
	"./RYS_9370.jpg": 91,
	"./Sielanka-wesele.JPG": 92,
	"./Sielanka-wesele2.JPG": 93,
	"./Sielanka_161.jpg": 94,
	"./Sielanka_39.jpg": 95,
	"./Sielanka_60.jpg": 96,
	"./Sielanka_63.jpg": 97
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;